import { Component } from '@angular/core';
import { IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';

@Component({
  selector: 'mav-dashboard',
  template: `
    <ion-header [translucent]="true">
      <ion-toolbar>
        <ion-title>Dashboard</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="flex h-full">
        <p class="m-auto">Order stats and stuff</p>
      </div>
    </ion-content>
  `,
  imports: [IonHeader, IonTitle, IonToolbar, IonContent],
})
export class DashboardPage {}
